<template>
  <v-card flat :loading="loading">
    <v-list :v-show="showGroup" dense style="max-height: 600px; overflow-y: auto;">
        <v-list-item-group>
          <v-list-item
              v-for="(group) in groupsFiltered"
              :key="group.name"
              :to="{ name: 'chats', params: { roomType: 'group', roomId: group.id }}"
              active-class="active"
              class="chat-private-channel"
              style="display: -webkit-box !important;"
          >
              <v-list-item-icon>
              <v-badge
                  color="orange"
                  :value="group.unread"
              >
                  <span slot="badge"> {{ group.unread }} </span>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :color="group.iconColor()" v-bind="attrs" v-on="on">{{ group.icon(currentUser) }}</v-icon>
                    </template>
                    <span>{{$t('chat.privateChannel')}}</span>
                  </v-tooltip>
              </v-badge>
              </v-list-item-icon>

              <v-list-item-content style="min-width: 145px !important;">
              <v-list-item-title>
                  <span :class="group.unread > 0 ? 'font-weight-bold' : 'font-weight-regular'">{{ group.displayUsername }}</span>
                  <div class="font-weight-light caption"><small>{{ capitalizeFirstLetter($t('chat.members.member')) }}s: {{group.usersCount}}</small></div>
              </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action style="margin: 0px !important;" v-if="chatsWrite" active-class="active">
              <v-menu style="z-index: 999">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-on:click.prevent
                        v-bind="attrs"
                        v-on="on"
                        class="context-menu-btn-private-channel"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                        v-for="(contextMenu, index) in group.contextMenus(currentUser)"
                        :key="index"
                        style="display: -webkit-box !important;"
                        class="context-menu-item-private-channel"
                        @click="navGroupContextMenu(contextMenu, group)"
                    >
                        <v-list-item-icon>
                        <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>
              </v-list-item-action>
          </v-list-item>
          <!-- Vuetify directive for infinite scroll / pagination -->
          <v-card v-intersect="infiniteScrolling"></v-card>
          <v-progress-circular
            style="margin: 0px !important;min-width: 185px !important;"
            v-show="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MixinChatHelper from '@/mixins/chat/helper'
import MixinChatRoomActions from '@/mixins/chat/room_actions'

export default {
  name: 'chat-nav_groups_list',
  mixins: [MixinChatHelper, MixinChatRoomActions],
  created () {
    this.getGroups()
  },
  computed: {
    ...mapGetters({
      currentUser: 'chat/authenticatedRocketChatUser',
      groups: 'chat/groups',
      loading: 'chat/groupsLoading',
      chatsWrite: 'permissions/chatsWrite',
      paginationGroups: 'chat/paginationGroups',
      groupsLoaded: 'chat/groupsLoaded',
      filterClosed: 'chat/GroupsFilters/closed',
      filterRead: 'chat/GroupsFilters/read',
      searchText: 'chat/GroupsFilters/search'
    }),
    groupsFiltered: function () {
      let filteredList = this.groups
      // Filter by open / close
      filteredList = filteredList.filter(group => {
        if (this.filterClosed) {
          return group.isCurrentUserParticipating(this.currentUser) && !group.isHidden()
        } else {
          return true
        }
      })
      // Filter by unread
      filteredList = filteredList.filter(group => {
        if (this.filterRead) {
          return group?.unread > 0
        } else {
          return true
        }
      })
      // Filter by search
      filteredList = filteredList.filter(group => {
        if (this.searchText) {
          return group.displayUsername.match(this.searchText)
        } else {
          return true
        }
      })
      return filteredList
    },
    showGroup: function () {
      return this.groups?.length > 0
    }
  },
  methods: {
    ...mapActions({
      getGroups: 'chat/getGroups',
      getMoreGroups: 'chat/getMoreGroups'
    }),

    async infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting && entries.length === 1 && this.groups?.length > 1 && !this.groupsLoaded) {
        await this.getMoreGroups()
      }
    }
  }
}
</script>

<style scoped>
.active{
  color: #1976d2;
}
</style>
